/*
  Footer link columns: on mobile (<750px) each column heading toggles its list
  open/closed (accordion, matching the Figma mobile footer). On desktop the
  columns are always expanded — CSS shows the content and the toggle is hidden,
  so clicks here are ignored above 750px. Content is visible by default (only
  `html.js` collapses it on mobile), so it stays accessible without JS.
*/
if (!customElements.get('footer-columns')) {
  customElements.define(
    'footer-columns',
    class FooterColumns extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      onClick = (event) => {
        const head = event.target.closest('[data-footer-head]');
        if (!head || !this.contains(head)) return;
        if (window.matchMedia('(min-width: 750px)').matches) return;

        const col = head.closest('[data-footer-col]');
        if (!col) return;
        const open = col.classList.toggle('is-open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
      };
    }
  );
}
